import React from "react";
import { useSnapshot } from "valtio";

import {
    generalConfigStore,
    designStore,
    setActionsButtonsItems,
} from "@store";

import { ActionsButtonsWrapper } from "@components/Common/Design/ActionsButtonsWrapper";

export function ActionsButtons(): JSX.Element {
    const { activePageName } = useSnapshot(designStore);
    const {
        project: {
            template: {
                pages: { ways },
            },
        },
    } = useSnapshot(generalConfigStore);

    const [localActionButtons, setLocalActionButtons] = React.useState<
        ActionsButtonsDesignItemType[]
    >((ways[activePageName] as PageType).actionsButtons.items);

    React.useEffect(() => {
        setActionsButtonsItems(localActionButtons);
        // eslint-disable-next-line
    }, []);

    return (
        <ActionsButtonsWrapper
            localActionsButtonsItems={localActionButtons}
            setLocalActionsButtonsItems={setLocalActionButtons}
        />
    );
}
